if (!customElements.get('tz-design-lab')) {
  customElements.define('tz-design-lab', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.buttons = Array.from(this.querySelectorAll('[data-select]'));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      if (this.panels.length) {
        this.setAttribute('data-enhanced','');
        this.buttons.forEach((button,index) => {
          button.addEventListener('click',()=>this.select(index),opts);
          button.addEventListener('keydown',event=>{
            let next;
            if(event.key==='ArrowRight') next=(this.current+1)%this.panels.length;
            if(event.key==='ArrowLeft') next=(this.current-1+this.panels.length)%this.panels.length;
            if(event.key==='Home') next=0;
            if(event.key==='End') next=this.panels.length-1;
            if(next!==undefined){event.preventDefault();this.select(next);this.buttons[next]?.focus({preventScroll:true});}
          },opts);
        });
        this.select(0,false);
      }
      this.addEventListener('shopify:block:select',event=>{
        const panel=event.target.closest('[data-panel]');
        if(panel && this.panels.includes(panel)) this.select(this.panels.indexOf(panel),false);
      },opts);
      const steps=Array.from(this.querySelectorAll('[data-step]'));
      if(steps.length){
        this.setAttribute('data-enhanced','');
        const images=Array.from(this.querySelectorAll('[data-step-image]'));
        images[0]?.setAttribute('data-active','');
        const showStep=index=>images.forEach((image,i)=>image.toggleAttribute('data-active',i===index));
        const update=()=>{
          this.stepFrame=0;
          const marker=window.innerHeight*(this.clientWidth<750?.66:.5);
          const nearest=steps.reduce((best,step,index)=>{
            const rect=step.getBoundingClientRect();
            const distance=marker<rect.top?rect.top-marker:marker>rect.bottom?marker-rect.bottom:0;
            return distance<best.distance?{index,distance}:best;
          },{index:0,distance:Infinity});
          showStep(nearest.index);
        };
        const schedule=()=>{if(!this.stepFrame)this.stepFrame=requestAnimationFrame(update);};
        window.addEventListener('scroll',schedule,{...opts,passive:true});
        window.addEventListener('resize',schedule,opts);
        this.addEventListener('shopify:block:select',event=>{
          const step=event.target.closest('[data-step]');
          if(step)showStep(Number(step.dataset.step));
        },opts);
        schedule();
      }
    }
    select(index,animate=true){
      this.current=index;
      this.panels.forEach((panel,i)=>{panel.toggleAttribute('data-active',i===index);panel.inert=i!==index;});
      this.buttons.forEach((button,i)=>{
        const tab=button.getAttribute('role')==='tab';
        button.setAttribute(tab?'aria-selected':'aria-pressed',String(i===index));
        if(tab) button.tabIndex=i===index?0:-1;
      });
      if(animate&&!this.motion.matches){
        this.animation?.cancel();
        this.animation=this.panels[index].animate([{opacity:.25,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:450,easing:'cubic-bezier(.2,.7,.2,1)'});
      }
    }
    disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.stepFrame);this.animation?.cancel();}
  });
}
